import { Button } from 'foundations-components/transitional/components/Button';
import DocumentPreviewForm from './DocumentPreviewForm';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { forwardRef, useCallback, useState } from 'react';
import { useTheme } from 'foundations-theming/utils';
import { EditIcon } from 'foundations-assets/icons/components/EditIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const DocumentPreviewPopover = /*#__PURE__*/forwardRef(({
  previewTitle,
  description,
  setPreviewTitle,
  setDescription,
  updatePreview
}, ref) => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const handleOpenChange = useCallback(e => {
    setOpen(e.target.value);
  }, [setOpen]);
  const handleCancel = useCallback(() => {
    setOpen(false);
  }, [setOpen]);
  const toggleOpen = useCallback(() => {
    setOpen(!open);
  }, [setOpen, open]);
  const handleConfirm = useCallback(({
    title,
    desc
  }) => {
    setPreviewTitle(title);
    setDescription(desc);
    updatePreview({
      title,
      desc
    });
    setOpen(false);
  }, [setPreviewTitle, setDescription, updatePreview]);
  return /*#__PURE__*/_jsx(Popover, {
    open: open,
    onOpenChange: handleOpenChange,
    content: /*#__PURE__*/_jsx(DocumentPreviewForm, {
      previewTitle: previewTitle,
      previewDescription: description,
      onConfirm: handleConfirm,
      onCancel: handleCancel,
      ref: ref
    }),
    closeOnOutsideClick: true,
    placement: "top",
    animateOnToggle: false,
    children: /*#__PURE__*/_jsx("div", {
      style: {
        margin: theme.space['200'],
        position: 'absolute',
        bottom: '0',
        right: '0'
      },
      children: /*#__PURE__*/_jsx(Button, {
        size: "small",
        onClick: toggleOpen,
        "data-test-id": "document-link-preview-edit-button",
        children: /*#__PURE__*/_jsx(EditIcon, {})
      })
    })
  });
});
export default DocumentPreviewPopover;